import { ethers } from "ethers";

// YOUR DEPLOYED CONTRACT ADDRESS
export const CONTRACT_ADDRESS = "0xD76873C7c794F4Bb04Ad272AD7Fb6F305AcE8124";

// YOUR CONTRACT's ABI
export const MOOD_NFT_ABI = [
    // Paste the full ABI from your compiled contract here
    // Example from a similar contract:
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "enum MoodNFT.Mood",
        "name": "mood",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "tokenURI",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "name": "NFTMinted",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getNFTDetails",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "enum MoodNFT.Mood",
            "name": "mood",
            "type": "uint8"
          },
          {
            "internalType": "string",
            "name": "tokenURI",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "internalType": "struct MoodNFT.NFTDetails",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "getUserNFTs",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "enum MoodNFT.Mood",
        "name": "mood",
        "type": "uint8"
      }
    ],
    "name": "mint",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "enum MoodNFT.Mood",
        "name": "mood",
        "type": "uint8"
      },
      {
        "internalType": "string",
        "name": "newURI",
        "type": "string"
      }
    ],
    "name": "updateMoodURI",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
   {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

// Metadata for frontend previews
export const MOOD_METADATA = {
    // HAPPY: 0
    0: { 
        name: "Happy Mood NFT", 
        image: "https://gateway.pinata.cloud/ipfs/bafybeigasjnb7gr4joyl3kvfxyi3pd4xw434ajzkcqrhaxn4anxzp6lyle",
        emoji: "😊",
        color: "#FFD700"
    },
    // SAD: 1
    1: { 
        name: "Sad Mood NFT", 
        image: "https://gateway.pinata.cloud/ipfs/bafkreidh5twmlr5llvhbtxmbu2qvuujowrjejsaxuy6eofn7vjqxbra32y",
        emoji: "😢",
        color: "#4169E1"
    },
    // ANGRY: 2
    2: { 
        name: "Angry Mood NFT", 
        image: "https://gateway.pinata.cloud/ipfs/bafkreihhn6fcatj6iybzhmhcfxjyfahrqgmfhang6tucfddjkz7croxzg4",
        emoji: "😡",
        color: "#DC143C"
    },
    // SURPRISED: 3
    3: { 
        name: "Surprised Mood NFT", 
        image: "https://gateway.pinata.cloud/ipfs/bafkreiafumr5lyunfcq7d42syh2j4extdkzl52efujwoqu6rib25fgaxdi",
        emoji: "😲",
        color: "#FF69B4"
    },
    // NEUTRAL: 4
    4: { 
        name: "Neutral Mood NFT", 
        image: "https://gateway.pinata.cloud/ipfs/bafkreigmqgoq337kftbfcqrvtm5in6cg773r6pvdfstiqb7xnr4we5itxm",
        emoji: "😐",
        color: "#808080"
    }
};

// Mapping from emotion name (from AI) to contract enum ID
export const MOOD_MAPPING = {
  'HAPPY': 0,
  'SAD': 1,
  'ANGRY': 2,
  'SURPRISED': 3,
  'NEUTRAL': 4
};

// Connect to the blockchain using ethers
let provider, signer, contract;

export const connectBlockchain = async () => {
    if (!window.ethereum) {
        throw new Error("MetaMask is not installed. Please install it to use this app.");
    }

    provider = new ethers.BrowserProvider(window.ethereum);
    signer = await provider.getSigner();
    contract = new ethers.Contract(CONTRACT_ADDRESS, MOOD_NFT_ABI, signer);
    
    const address = await signer.getAddress();
    
    return { provider, signer, contract, address };
};
